/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentReport {
    getFixupPrototypeFunction() { return AiAgentReport.fixupPrototype; }

    static newInstance(model: Partial<AiAgentReport>): AiAgentReport {
        let obj = Object.assign(new AiAgentReport(), model);
        AiAgentReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentReport>): AiAgentReport {
        if (!model) return null;
        return AiAgentReport.newInstance(<AiAgentReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentReport) {
        if (!obj) return;

        models.AiAgentReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentReport): boolean {
        Object.setPrototypeOf(obj, AiAgentReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.background_job) {
            models.RecordIdentity.fixupPrototype(this.background_job);
        }
    }

    /**
     * Unique ID for the report
     */
    sys_id: string;

    /**
     * Identity of the background job used to generate the report, null if the job has completed
     */
    background_job: models.RecordIdentity;

    /**
     * ID of the attachment where the report contents are stored.
     */
    attachment_id: string;

}
